import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@g99-product-web-ui/core-lib';
import {
  IAuthResponse,
  IPublicBusinessConfig,
} from '@g99-product-web-ui/shared-interface-lib';
import {
  LocalStorageService,
  SubjectManageService,
} from '@g99-product-web-ui/shared-service';
import { RoleNameEnum } from '@g99-product-web-ui/shared-util-lib';

import { IProfileMenuItem } from '../../interfaces/IMenu.interface';

@Component({
  selector: 'g99-lib-header-popover',
  templateUrl: './header-popover.component.html',
  styleUrl: './header-popover.component.scss',
  standalone: false,
})
export class HeaderPopoverComponent implements OnInit {
  @Input() public usersData!: IAuthResponse; // input for user data
  @Input() public profileMenus: IProfileMenuItem[] = []; // input for profile menus
  @Input() public userRole!: string;
  @Input() public isShowProfileDropdown!: boolean; // to show and hide popover
  @Input() public businessData!: IPublicBusinessConfig;
  @Output() public profileMenuClick = new EventEmitter<{
    route: string;
    label: string;
  }>(); // event emitter for menu item clicks
  protected timestamp: number = Date.now();
  protected RoleNameEnum = RoleNameEnum;
  protected isLinkedToMultipleBusinesses = false;

  constructor(
    private _localStorageService: LocalStorageService,
    private _authenticationService: AuthenticationService,
    private _subjectManagerService: SubjectManageService,
    private _router: Router
  ) {}

  ngOnInit() {
    const currentUser =
      this._localStorageService.readItem<IAuthResponse>('currentUser');

    this.isLinkedToMultipleBusinesses =
      currentUser?.isLinkedToMultipleBusinesses ?? false;
  }

  public onClickProfileMenu(route: string, label: string) {
    this.profileMenuClick.emit({ route, label });
  }

  protected onSwitchBusiness(): void {
    this.isShowProfileDropdown = false;
    const currentUser =
      this._localStorageService.readItem<IAuthResponse>('currentUser');

    // Safety check
    if (!currentUser || !currentUser.refreshToken) {
      this._router.navigate(['']);
      return;
    }

    // Step 1: Clear all local storage (clean session)
    this._localStorageService.clearStorage();

    // Step 2: Store only required switch-business credentials
    this._authenticationService.storeCredentials({
      email: currentUser.username, // Correct field
      refreshToken: currentUser.refreshToken,
      isSwitchBusiness: true,
    });
    this._subjectManagerService.userSubject.next(null);

    // Step 3: Redirect to business selection
    this._router.navigate(['/business-selection']);
  }
}
